import React, { useState } from "react";
import FlightActivity from "../../components/activities/FlightActivity";
import ToursActivity from "../../components/activities/ToursActivity";
import HotelsActivity from "../../components/activities/HotelsActivity";

type optionType = "Flights" | "Tours" | "Hotels";

function HomeGrowSection() {
  const [selected, setSelected] = useState<optionType>("Flights");

  const handleSelect = (option: optionType) => {
    setSelected(option);
  };

  const InViewActivity = () => {
    switch (selected) {
      case "Flights":
        return <FlightActivity />;
      case "Tours":
        return <ToursActivity />;
      case "Hotels":
        return <HotelsActivity />;
      default:
        return <FlightActivity />;
    }
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl mb-10 text-center">
          Grow no matter the activities you sell
        </span>

        <div className="flex w-full justify-evenly mb-10">
          <button
            className={
              selected === "Flights"
                ? Classname.buttonActive
                : Classname.buttonPassive
            }
            onClick={() => handleSelect("Flights")}
          >
            Flight
          </button>
          <button
            className={
              selected === "Tours"
                ? Classname.buttonActive
                : Classname.buttonPassive
            }
            onClick={() => handleSelect("Tours")}
          >
            Tours
          </button>
          <button
            className={
              selected === "Hotels"
                ? Classname.buttonActive
                : Classname.buttonPassive
            }
            onClick={() => handleSelect("Hotels")}
          >
            Hotels
          </button>
        </div>
        <InViewActivity />
      </div>
    </div>
  );
}

export default HomeGrowSection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  buttonActive:
    "text-sm lg:text-base text-white bg-primary px-6 py-2 rounded-lg",
  buttonPassive: "text-sm lg:text-base border px-6 py-2 rounded-md",
};
